import { render } from "./Traslados.vue?vue&type=template&id=724bbafc&scoped=true&ts=true"
import script from "./Traslados.vue?vue&type=script&lang=ts"
export * from "./Traslados.vue?vue&type=script&lang=ts"

import "./Traslados.vue?vue&type=style&index=0&id=724bbafc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724bbafc"]])

export default __exports__